export const PACKAGE_NAME = 'collect_actions';

export const ONE_FIVERR_MP_LISTS_TO_FREELANCE_NETWORK_MERGE_ROLLOUT =
    'marlins_one_fiverr_mp_lists_to_freelance_network_merge';
